export default {
  form: {
    owner_phone_number: {
      label: 'Numero di telefono del referente',
      placeholder: '1785080120',
    },
    owner_email: {
      label: 'E-mail del referente',
      placeholder: 'Inserisci e-mail',
    },
    owner_first_name: {
      label: 'Nome',
      placeholder: 'Inserisci il nome',
    },
    owner_last_name: {
      label: 'Cognome',
      placeholder: 'Inserisci il cognome',
    },
    owner_dob: {
      label: 'Data di nascita',
      placeholder: 'Data',
    },
    owner_id_number: {
      label: 'Numero identificativo (es. codice fiscale)',
      placeholder: '123456789',
    },
  },
  buttons: {
    back: 'Indietro',
    next: 'Avanti',
  },
};
